import { styled } from '@material-ui/core';
import {
  Sidebar,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarLogo } from './SidebarLogo';

const SidebarDivider = styled('hr')(({ theme }) => ({
  height: 1,
  width: '100%',
  background: 'rgb(90, 104, 114)',
  border: 'none',
  margin: theme.spacing(0, 0),
  marginTop: '6px',
  marginBottom: '6px',
}));

/**
 * Nav items that are rendered by hand further down (with their own component),
 * so they must not show up again in `nav.rest()`.
 */
const MANUALLY_RENDERED = ['page:notifications', 'page:user-settings'];

/**
 * Nav items that we do not want in the sidebar at all. The pages stay
 * reachable by URL — to remove a page entirely, disable its extension in
 * app-config.yaml instead.
 */
const HIDDEN = [
  'page:catalog-import',
  'page:catalog-graph',
  'page:announcements',
  'page:app-visualizer',
];

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Consume these before anything calls `rest()`, so they are dropped
      // from the list of leftover items.
      [...MANUALLY_RENDERED, ...HIDDEN].forEach(id => nav.take(id));

      return (
        <Sidebar disableExpandOnHover>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />}>
            {nav.take('page:search')}
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:home')}
            {nav.take('page:guide')}
            {nav.take('page:catalog')}
            {nav.take('page:api-docs')}
            {nav.take('page:techdocs')}
            {nav.take('page:qeta')}
            {nav.take('page:adoption')}
            {nav.take('page:nvd')}
            {nav.take('page:tech-radar')}
            <SidebarDivider />
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            <SidebarSettings />
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
